import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Always set to current local time if field is empty
    if (!this.element.value) {
      const now = new Date();

      // Format as YYYY-MM-DDTHH:MM for datetime-local input
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");

      this.element.value = `${year}-${month}-${day}T${hours}:${minutes}`;
    }

    // Add timezone info so Rails knows user's timezone
    this.addTimezoneField();
  }

  addTimezoneField() {
    const form = this.element.closest("form");
    if (!form) return;

    // Remove existing timezone field if any
    const existingField = form.querySelector(
      'input[name="user_timezone_offset"]',
    );
    if (existingField) existingField.remove();

    // Create hidden field with timezone offset in minutes
    const now = new Date();
    const timezoneField = document.createElement("input");
    timezoneField.type = "hidden";
    timezoneField.name = "user_timezone_offset";
    timezoneField.value = -now.getTimezoneOffset(); // offset in minutes

    form.appendChild(timezoneField);
  }
}
